'use strict';


/**
 * Convert various measurement units between themselves.
 *
 * @param {(string|number)} baseValue - unit to convert
 * @param {string} direction - determine "FROM" (first 2 letters) units and "TO" (last 2 letters) units
 * @return {number} rounded digit as a result of particular conversion or original digit
 */
module.exports = function ( baseValue, direction ) {
    var map;

    baseValue = parseFloat(baseValue);

    map = {
        // Celsius --> Fahrenheit
        CF: Math.floor((baseValue * 9 / 5) + 32) + '\u00B0F',
        // Fahrenheit --> Celsius
        FC: Math.floor((baseValue - 32) * 5 / 9) + '\u00B0C',
        // Metres per second --> Kilometres per hour
        MSKH: Math.floor(baseValue * 3.6) + gettext('km/h'),
        // Kilometres per hour --> Metres per second
        KHMS: Math.floor(baseValue * 0.277778) + gettext('m/s'),
        // Metres per second --> Miles per hour
        MSMH: Math.floor(baseValue * 2.236936) + gettext('m/h'),
        // Miles per hour --> Metres per second
        MHMS: Math.floor(baseValue * 0.44704) + gettext('m/s'),
        // Kilometres per hour --> Miles per hour
        KHMH: Math.floor(baseValue * 0.621371) + gettext('m/h'),
        // Miles per hour --> Kilometres per hour
        MHKH: Math.floor(baseValue * 1.609344) + gettext('km/h')
    };

    if ( !map[direction] ) {
        throw new Error('Incorrect direction to convert, use the following: CF/FC/MSKH/MSMH/KHMS/KHMH/MHMS/MHKH');
    }

    return map[direction];
};
